import {mapStateToProps, mapDispatchToProps} from "../redux/redux";
import {connect} from "react-redux";
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardTitle, Row, Col, Label, Input, UncontrolledCollapse } from 'reactstrap';

export let state = null;
const SettingsTabsCon = (props) => {
    const [activeTab, setActiveTab] = useState(`${props.state.tab}`);
    const [input, setInput] = useState({measure: props.state.measure, barsQuant: props.state.barsQuant, bpm: props.state.bpm});
    
    function inputReceive(e) {
        let inputTemp = {...input};
        let value = e.target.value;

        if (value == Number(value)) value = Number(value);
        inputTemp[e.target.id] = value;
        setInput(inputTemp);
        state = inputTemp;
        if (e.target.id !== "bpm" && !props.state.custom) {
            props.updateState({custom: true})
        }
    }

    const toggle = tab => {
      if(activeTab !== tab) setActiveTab(tab);
    }

    useEffect(() => {
        state = input;
        // return () => {
        //     props.updateState(state)
        //     setTimeout(() => props.nextGen(), 50);
        // }
    }, [])


        return(
            <div>
    
                <div className="settings__tabs">
                    <Nav tabs>
                        <NavItem>
                            <NavLink className={classnames({ active: activeTab === '1' })} onClick={() => { toggle('1'); props.updateState({tab: 1})}}>
                                Score Settings
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={classnames({ active: activeTab === '2' })} onClick={() => { toggle('2'); props.updateState({tab: 2})}}>
                                Bar Settings
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={classnames({ active: activeTab === '3' })} onClick={() => { toggle('3'); props.updateState({tab: 3})}}>
                                Values Probability
                            </NavLink>
                        </NavItem>
                </Nav>

                <TabContent activeTab={activeTab} className="settings__tabs__content">
                    <TabPane tabId="1">
                        <Row>
                            <Col md="4">
                                <Card body>
                                    <CardTitle>Measure</CardTitle>
                                    <Row className="mb-2">
                                        <Col md="4">
                                            <button className="btn card__item" id="measure" value="two_quarters" disabled={input.measure === "two_quarters"} onClick={inputReceive}>2/4</button>
                                        </Col>
                                        <Col md="4">
                                            <button className="btn card__item" id="measure" value="three_quarters" disabled={input.measure === "three_quarters"} onClick={inputReceive}>3/4</button>
                                        </Col>
                                        <Col md="4">
                                            <button className="btn card__item" id="measure" value="four_quarters" disabled={input.measure === "four_quarters"} onClick={inputReceive}>4/4</button>
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col md="4">
                                            <button className="btn card__item" id="measure" value="five_quarters" disabled={input.measure === "five_quarters"} onClick={inputReceive}>5/4</button>
                                        </Col>
                                        <Col md="4">
                                            <button className="btn card__item" id="measure" value="seven_quarters" disabled={input.measure === "seven_quarters"} onClick={inputReceive}>7/4</button>
                                        </Col>
                                        <Col md="4">
                                            <button className="btn card__item" id="measure" value="five_eights" disabled={input.measure === "five_eights"} onClick={inputReceive}>5/8</button>
                                        </Col>
                                    </Row>
                                   <Row>
                                       <Col md={{size: "4", offset: "4"}}>
                                           <button className="btn card__item" id="measure" value="six_eights" disabled={input.measure === "six_eights"} onClick={inputReceive}>6/8</button>
                                       </Col>
                                   </Row>
                                
                                    
                                </Card>
                            </Col>
                            <Col md="3">
                                <Card body>
                                    <CardTitle>Bar quantity</CardTitle>
                                        <Row className="mb-2">
                                            <Col md="4">
                                                <button className="btn card__item" id="barsQuant" value="4" disabled={input.barsQuant === 4} onClick={inputReceive}>4</button>
                                            </Col>
                                            <Col md="4">
                                                <button className="btn card__item" id="barsQuant" value="8" disabled={input.barsQuant === 8} onClick={inputReceive}>8</button>
                                            </Col>
                                            <Col md="4">
                                                <button className="btn card__item" id="barsQuant" value="10" disabled={input.barsQuant === 10} onClick={inputReceive}>10</button>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md="4">
                                                <button className="btn card__item" id="barsQuant" value="12" disabled={input.barsQuant === 12} onClick={inputReceive}>12</button>
                                            </Col>
                                            <Col md="4">
                                                <button className="btn card__item" id="barsQuant" value="16" disabled={input.barsQuant === 16} onClick={inputReceive}>16</button>
                                            </Col>
                                            <Col md="4">
                                                <button className="btn card__item" id="barsQuant" value="20" disabled={input.barsQuant === 20} onClick={inputReceive}>20</button>
                                            </Col>
                                        </Row>
                                </Card>
                            </Col>
                            <Col md="3">
                                <Card body>
                                    <CardTitle>BPM</CardTitle>
                                    <Row>
                                        <Col md={{size: "4", offset: "4"}}>
                                            <Input type="number" name="selectMulti" id="bpm" value={input.bpm} onChange={inputReceive}>
                                            </Input>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                        
                        
                    </TabPane>

                    <TabPane tabId="2" className="tab__bar-settings">
                        <Row>
                            <Col md={{size: "6", offset: "3"}}>
                                <Card body>
                                    <Label>
                                        Longer notes on beat
                                        <Input type="range" defaultValue={props.state.easyOBProb}/>
                                    </Label>
                                    
                                    <Label>
                                        Aspiration to strong and weak beats
                                        <Input type="range" defaultValue={props.state.fixingBeatProb}/>
                                    </Label>

                                    <Label>
                                        Pause value
                                        <Input type="range" defaultValue={props.state.pauseValue}/>
                                    </Label>

                                    <Label className="settings__tabs__content__checkbox">
                                        <Input type="checkbox" defaultChecked={props.state.groupRest}/> Summing rests
                                    </Label>

                                    <Label className="settings__tabs__content__checkbox">
                                        <Input type="checkbox" defaultChecked={props.state.linkIns}/> Link inside bar
                                    </Label>

                                    <Label>
                                        Link outside the bar
                                        <Input type="range" defaultValue={props.state.linkOut}/>
                                    </Label>

                                    <Label className="settings__tabs__content__checkbox">
                                        <Input type="checkbox" defaultChecked={props.state.showBeat}/> Show beat (beaming)
                                    </Label>
                                </Card>
                            </Col>
                        </Row>
                    </TabPane>

                    <TabPane tabId="3">
                        <Row>
                            <Col md="6" className="mb-4">
                                <Card body>
                                    <CardTitle>Simple note values</CardTitle>

                                    <Label>
                                        <Input type="range" defaultValue={props.state.simpleK * 100 / props.state.maxK}/>
                                    </Label>
                                    <Row>
                                        <Col md={{size: "4", offset: "4"}} className="mb-2 mt-2">
                                            <button className="btn btn-secondary" id="simpleVals">Settings</button>
                                        </Col>
                                    </Row>

                                    <UncontrolledCollapse toggler="#simpleVals">
                                        <Row>
                                            <Col md="2">
                                                <Input type="range" className="input" defaultValue={props.state.noteValues.whole}></Input>
                                            </Col>
                                            <Col md="2">
                                                <Input type="range" className="input" defaultValue={props.state.noteValues.half}></Input>
                                            </Col>
                                            <Col md="2">
                                                <Input type="range" className="input" defaultValue={props.state.noteValues.quarter}></Input>
                                            </Col>
                                            <Col md="2">
                                                <Input type="range" className="input" defaultValue={props.state.noteValues.eighth}></Input>
                                            </Col>
                                            <Col md="2">
                                                <Input type="range" className="input" defaultValue={props.state.noteValues.sixteenth}></Input>
                                            </Col>
                                            <Col md="2">
                                                <Input type="range" className="input" defaultValue={props.state.noteValues.thirtySecond}></Input>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md="2">
                                                <p>whole</p>
                                            </Col>
                                            <Col md="2">
                                                <p>half</p>
                                            </Col>
                                            <Col md="2">
                                                <p>quarter</p>
                                            </Col>
                                            <Col md="2">
                                                <p>eighth</p>
                                            </Col>
                                            <Col md="2">
                                                <p>sixteenth</p>
                                            </Col>
                                            <Col md="2">
                                                <p>thirty-second</p>
                                            </Col>
                                        </Row>

                                    </UncontrolledCollapse>
                                        
                                </Card>
                            </Col>

                            <Col md="6" className={props.state.dotsK <= 0 ? "card--inactive mb-4" : "mb-4"}>
                                <Card body>
                                    <CardTitle>Dotted note values</CardTitle>

                                    <Label>
                                        <Input type="range" defaultValue={props.state.dotsK * 100 / props.state.maxK}/>
                                    </Label>

                                    <Row>
                                        <Col md={{size: "4", offset: "4"}} className="mb-2 mt-2">
                                            <button className="btn btn-secondary" id="dottedVals">Settings</button>
                                        </Col>
                                    </Row>

                                    <UncontrolledCollapse toggler="#dottedVals">
                                        <Row>
                                            <Col md="2">
                                                <Input type="range" className="input" defaultValue={props.state.dottedValues.whole}></Input>
                                            </Col>
                                            <Col md="2">
                                                <Input type="range" className="input" defaultValue={props.state.dottedValues.half}></Input>
                                            </Col>
                                            <Col md="2">
                                                <Input type="range" className="input" defaultValue={props.state.dottedValues.quarter}></Input>
                                            </Col>
                                            <Col md="2">
                                                <Input type="range" className="input" defaultValue={props.state.dottedValues.eighth}></Input>
                                            </Col>
                                            <Col md="2">
                                                <Input type="range" className="input" defaultValue={props.state.dottedValues.sixteenth}></Input>
                                            </Col>
                                            <Col md="2">
                                                <Input type="range" className="input" defaultValue={props.state.dottedValues.thirtySecond}></Input>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md="2">
                                                <p>whole</p>
                                            </Col>
                                            <Col md="2">
                                                <p>half</p>
                                            </Col>
                                            <Col md="2">
                                                <p>quarter</p>
                                            </Col>
                                            <Col md="2">
                                                <p>eighth</p>
                                            </Col>
                                            <Col md="2">
                                                <p>sixteenth</p>
                                            </Col>
                                            <Col md="2">
                                                <p>thirty-second</p>
                                            </Col>
                                        </Row>
                                    </UncontrolledCollapse>
                                    
                                </Card>
                            </Col>

                            <Col md={{size: "6", offset: "3"}} className={props.state.groupK <= 0 ? "card--inactive mb-4" : "mb-4"}>
                                <Card body>
                                    <CardTitle>Tuplet note values</CardTitle>

                                    <Label>
                                        <Input type="range" defaultValue={props.state.groupK * 100 / props.state.maxK}/>
                                    </Label>

                                    <Row>
                                        <Col md={{size: "4", offset: "4"}} className="mb-2 mt-2">
                                            <button className="btn btn-secondary" id="tupletVals">Settings</button>
                                        </Col>
                                    </Row>

                                    <UncontrolledCollapse toggler="#tupletVals">
                                       <Row>
                                            <Col md="3">
                                                <Input type="range" className="input" defaultValue={props.state.groupingValues.whole}></Input>
                                            </Col>
                                            <Col md="3">
                                                <Input type="range" className="input" defaultValue={props.state.groupingValues.half}></Input>
                                            </Col>
                                            <Col md="3">
                                                <Input type="range" className="input" defaultValue={props.state.groupingValues.quarter}></Input>
                                            </Col>
                                            <Col md="3">
                                                <Input type="range" className="input" defaultValue={props.state.groupingValues.eighth}></Input>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md="3">
                                                <p>whole</p>
                                            </Col>
                                            <Col md="3">
                                                <p>half</p>
                                            </Col>
                                            <Col md="3">
                                                <p>quarter</p>
                                            </Col>
                                            <Col md="3">
                                                <p>eighth</p>
                                            </Col>
                                        </Row> 

                                        <Label>
                                            Quinteplet Probability
                                            <Input type="range" defaultValue={100 - props.state.tripletValue}/>
                                        </Label>

                                        <Row>
                                        <Col md={{size: "4", offset: "4"}} className="mb-2 mt-2">
                                            <button className="btn btn-secondary" id="quintepletProb" disabled={props.state.tripletValue === 100}>Quinteplet Map</button>
                                        </Col>
                                    </Row>

                                    <UncontrolledCollapse toggler="#quintepletProb">
                                       <Row>
                                            <Col md="3">
                                                <Input type="range" className="input" defaultValue={props.state.quintepletMap.whole}></Input>
                                            </Col>
                                            <Col md="3">
                                                <Input type="range" className="input" defaultValue={props.state.quintepletMap.half}></Input>
                                            </Col>
                                            <Col md="3">
                                                <Input type="range" className="input" defaultValue={props.state.quintepletMap.quarter}></Input>
                                            </Col>
                                            <Col md="3">
                                                <Input type="range" className="input" defaultValue={props.state.quintepletMap.eighth}></Input>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md="3">
                                                <p>whole</p>
                                            </Col>
                                            <Col md="3">
                                                <p>half</p>
                                            </Col>
                                            <Col md="3">
                                                <p>quarter</p>
                                            </Col>
                                            <Col md="3">
                                                <p>eighth</p>
                                            </Col>
                                        </Row> 
                                    </UncontrolledCollapse>
                                    </UncontrolledCollapse>
                                    
                                </Card>
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
                </div>
                
            </div>
        )
    }


export let SettingsTabs = connect(mapStateToProps, mapDispatchToProps)(SettingsTabsCon);
